import { Box } from "@chakra-ui/react"
import dynamic from "next/dynamic"
import { FhResponseData } from "../../../../common/types/search"
import PartialResultsSingleTerm from "./PartialResultsSingleTerm/PartialResultsSingleTerm"

const Loader = dynamic(() => import("../../../shared/Loader"), { ssr: false, loading: () => <Box mt="12" /> })

type Props = {
  isLoading: boolean
  partials: FhResponseData
}

const PartialResultsView = ({ isLoading, partials }: Props) => {
  return (
    <>
      {isLoading ? (
        <Loader mt="12" />
      ) : (
        partials.map(({ items, numberOfResults, originalSearchTerm, partialSearchTerm, rid }) => {
          return (
            <PartialResultsSingleTerm
              items={items}
              key={partialSearchTerm}
              numberOfResults={numberOfResults}
              originalSearchTerm={originalSearchTerm}
              partialSearchTerm={partialSearchTerm}
              rid={rid}
            />
          )
        })
      )}
    </>
  )
}

export default PartialResultsView
